import { createContext, use } from "react";
import { IJMEditorContextType } from "./types";

export const IJMEditorContext = createContext<IJMEditorContextType | undefined>(undefined);

export const useIJMEditorContext = () => {
    const context = use(IJMEditorContext);
    if (!context) {
        throw new Error("useIJMEditorContext must be used within IJMEditorNavigator");
    }
    return context;
};
